<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <ward-form></ward-form>
      </div>
    </div>
  </div>
</template>

<script>
import WardForm from "@/views/ward/components/Form.vue";

export default {
  name: "add-ward",
  components: {
    WardForm,
  }
};
</script>